import {writable} from 'svelte/store';

type SessionDataType = {
    gender: string;
    isSessionSubscribed: boolean;
};

const initialValue = {
    gender: '',
    isSessionSubscribed: false,
};

const createCustomerStore = () => {
    const {subscribe, update, set} = writable(<SessionDataType>{...initialValue});

    return {
        subscribe,
        setGender: (newGender: string) => {
            update(currentValue => ({
                ...currentValue,
                gender: newGender,
            }));
        },
        setSessionSubscribed: (isSubscribed: boolean) => {
            update(currentValue => ({
                ...currentValue,
                isSessionSubscribed: isSubscribed,
            }));
        },
        reset: () => {
            set({...initialValue});
        },
    };
};

export const sessionData = createCustomerStore();
